import { render, staticRenderFns } from "./PromotionEditLegacy.vue?vue&type=template&id=03767996&scoped=true"
import script from "./PromotionEditLegacy.vue?vue&type=script&lang=js"
export * from "./PromotionEditLegacy.vue?vue&type=script&lang=js"
import style0 from "./PromotionEditLegacy.vue?vue&type=style&index=0&id=03767996&prod&lang=scss&scoped=true"
import style1 from "./PromotionEditLegacy.vue?vue&type=style&index=1&id=03767996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03767996",
  null
  
)

export default component.exports